<ion-header class="smm-header">
  <ion-toolbar>
    <ion-title>{{ 'chat.suggestedMessages.title' | translate }}</ion-title>
    <ion-button slot="end" fill="clear" (click)="dismiss()" [attr.aria-label]="'chat.suggestedMessages.close' | translate">
      <ion-icon slot="icon-only" name="close-outline"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-content class="smm-content">
  @for (entry of entries(); track entry.characterId) {
  <div class="smm-entry">
    @if (characterName(entry.characterId)) {
    <p class="smm-char-name">{{ characterName(entry.characterId) }}</p>
    }
    @for (choice of entry.choices; track $index) {
    <button
      class="smm-choice"
      [class.smm-choice--selected]="isSelected(entry.characterId, $index)"
      (click)="select(entry.characterId, $index, choice)"
      type="button"
    >
      <span class="smm-choice-header">
        <span class="smm-choice-label">{{ choiceLabel(choice) }}</span>
        @if (choiceHasRoll(choice)) {
        <ion-icon class="smm-roll-badge" name="dice-outline" aria-hidden="true"></ion-icon>
        }
      </span>
      <span class="smm-choice-message">{{ choicePreview(choice) }}</span>
      @if (choiceRollDescription(choice); as rollDesc) {
      <span class="smm-choice-roll-desc">{{ rollDesc }}</span>
      }
    </button>
    }
  </div>
  }
</ion-content>

<ion-footer class="re-primary-action-footer smm-footer">
  <ion-toolbar>
    <ion-button
      expand="block"
      [disabled]="!selected()"
      (click)="confirm()"
    >
      <ion-icon slot="start" name="checkmark-outline"></ion-icon>
      {{ 'chat.suggestedMessages.send' | translate }}
    </ion-button>
  </ion-toolbar>
</ion-footer>
